import React, { useState, useEffect } from "react"; // eslint-disable-line no-unused-vars
import { ThankYou } from "../components";
import {
  getSettings,
  fetchCodeDetails,
  clearCookies,
} from "../../../shared/utilities/actions";
import {
  CodeDetails,
  DefaultCodeDetails,
  Settings,
  DefaultSettings,
} from "../../../shared/types";

export interface MainProps {}

export const Main = ({}: MainProps): React.JSX.Element => {
  const [codeDetails, setCodeDetails] = useState<CodeDetails>({
    ...DefaultCodeDetails,
  });
  const [settings, setSettings] = useState<Settings>({ ...DefaultSettings });
  const [busy, setBusy] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      setBusy(true);
      let themeId = fetchCodeDetails(codeDetails.themeId, setCodeDetails);
      let settingsResponse: Settings = await getSettings(themeId);
      await clearCookies();
      setSettings(settingsResponse);
      setBusy(false);
    };
    fetchData();
  }, []);

  return <ThankYou busy={busy} settings={settings} />;
};
